import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Markdown from 'react-markdown';
import { Column, Title, Text } from '../../theme/index';
import styled from 'styled-components';
import Header from '../../shared/Header';
import Splash from '../../shared/Splash';
import Footer from '../../shared/Footer';
import moment from 'moment';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const StyledColumn = styled(Column)`
  width: 60%;
  margin: 3em auto;
  @media (max-width: 500px) {
    width: 90%;
  }
`;

const Post = ({ data: { loading, error, post } }) => {
  if (error) return <h1>Error fetching the post!</h1>;
  if (!loading) {
    return (
      <Wrapper>
        <Header />
        <Splash
          id="post"
          img={`https://media.graphcms.com/resize=w:650,h:366,fit:crop/${
            post.mainArtwork.handle
          }`}
          text={['', `${post.excerpt}`]}
        />
        <StyledColumn>
          <Title>{post.title}</Title>
          <Text instructortitle>{moment(post.date).format('MMM Do YY')}</Text>
          <Markdown
            className="postBody"
            source={post.body}
            escapeHtml={false}
          />
        </StyledColumn>
        <Footer />
      </Wrapper>
    );
  } else {
    return null;
  }
};

export const singlePost = gql`
  query singlePost($id: ID!) {
    post(where: { id: $id }) {
      id
      slug
      title
      excerpt
      mainArtwork {
        handle
      }
      body
      date
    }
  }
`;

export default graphql(singlePost, {
  options: ({ match }) => ({
    variables: {
      id: match.params.slug,
    },
  }),
})(Post);



// WEBPACK FOOTER //
// ./src/components/screens/Post/Post.jsx